import { FormattedMessage } from "react-intl";
import "../styles/Footer.css";

const Footer = () => {
  const lang = navigator.language,
        baseURL = `https://gr.trendmicro.com/GREntry/NonPayment?Target=Link&FUNID={0}&PID=MS20&Locale=${lang}`,
        policyURL = baseURL.replace("{0}", "Privacy"),
        contactURL = baseURL.replace("{0}", "ContactUs"),
        rootURL = "https://mobilesecurity.trendmicro.com/";
  
  return (
    <div className="footer">
        <div className="footer-container">
          <div className="footer-desc">
            <div>
              <a target="_self" href={ policyURL }>
                <FormattedMessage id="policies_privacy" />
              </a>
            </div>
            &nbsp;•&nbsp;
            <div>
              <a target="_self" href={ contactURL }>
                <FormattedMessage id="contact_us" />
              </a>
            </div>
            &nbsp;•&nbsp;
            <div>
              <a target="_self" href={ rootURL }>
                <FormattedMessage id="trendmicrocom" />
              </a>
            </div>
          </div>
          <div className="footer-logo"></div>
          <p className="footer-copyright">
            <FormattedMessage id="copyright_statement" />
          </p>
        </div>
    </div>
  );
};

export default Footer;
